import { isOnPage } from './utils';

/* global Cookies */

const elements = {};

const state = {
  hintActive: false,
  city: null,
  cityConfirmed: false,
};

const render = (s) => {
  if (s.hintActive) {
    elements.hint.classList.add('show');
  } else {
    elements.hint.classList.remove('show');
  }
};

const initLocation = () => {
  elements.hint = document.getElementById('location-hint');
  elements.confirmBtn = document.getElementById('location-confirm');
  elements.changeBtn = document.getElementById('location-change');

  state.city = elements.hint.dataset.city;

  state.cityConfirmed = (elements.hint.dataset.confirmed === '1' || Cookies.get('city_confirmed') === 'yes');
  state.hintActive = !state.cityConfirmed;

  if (state.cityConfirmed) {
    Cookies.set('city', state.city, { expires: 365 });
    Cookies.set('city_confirmed', 'yes', { expires: 365 });
  }

  elements.confirmBtn.addEventListener('click', () => {
    state.hintActive = false;
    Cookies.set('city', state.city, { expires: 365 });
    Cookies.set('city_confirmed', 'yes', { expires: 365 });

    render(state);
  });

  elements.changeBtn.addEventListener('click', () => {
    state.hintActive = false;

    render(state);
  });

  render(state);
};

if (isOnPage('#location-hint')) {
  initLocation();
}
